import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledEllipsesIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg width='5' height='18' viewBox='0 0 5 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <circle cx='2.07212' cy='2.50955' r='1.94712' />
            <circle cx='2.07212' cy='8.99997' r='1.94712' />
            <circle cx='2.07212' cy='15.4903' r='1.94712' />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}
    fill: ${p => p.theme.playerIconsColor};
`
